import React from "react";
import { Check } from "lucide-react";

const LABELS = ["Box Size", "Flavors", "Pickup", "Tip", "Review"];

export default function StepIndicator({ current = 1 }) {
  return (
    <div className="flex items-center justify-center gap-2 md:gap-3 px-2 mb-10 md:mb-14" data-testid="step-indicator">
      {LABELS.map((label, i) => {
        const step = i + 1;
        const status = step < current ? "done" : step === current ? "active" : "pending";
        return (
          <React.Fragment key={label}>
            <div className="flex flex-col items-center gap-2">
              <div className={`step-dot ${status}`} data-testid={`step-${step}-dot`}>
                {status === "done" ? <Check className="w-4 h-4" /> : step}
              </div>
              <span className={`text-[0.65rem] md:text-xs font-bold uppercase tracking-widest ${status === "pending" ? "text-white/60" : "text-white drop-shadow"}`}>
                {label}
              </span>
            </div>
            {i < LABELS.length - 1 && <div className={`step-bar ${step < current ? "done" : ""}`} />}
          </React.Fragment>
        );
      })}
    </div>
  );
}
